<path
    d="M12.2045 6.96611L17.9255 7.42509L13.566 11.1588L14.8982 16.7415L9.99988 13.75L5.1016 16.7415L6.4338 11.1588L2.07426 7.42509L7.79529 6.96611L9.99988 1.66663L12.2045 6.96611ZM8.65629 8.151L5.16996 8.43014L7.82621 10.7063L7.01485 14.108L9.99988 12.2851L12.9841 14.108L12.1735 10.7063L14.829 8.43014L11.3435 8.151L9.99988 4.92102L8.65629 8.151Z"
    fill="currentColor"
/>
<path
    d="M9.99967 1.67965V13.7532L9.99398 13.75L5.0957 16.7415L6.42708 11.1588L2.06836 7.42509L7.78939 6.96611L9.99398 1.66663L9.99967 1.67965Z"
    fill="currentColor"
/>
